import { createAction, props } from '@ngrx/store';

export enum RuleEngineActionTypes {
  Save_Rule_Engine_Obj = '[RuleEngine] Save_Rule_Engine_Obj',
  Initialize_DefaultRuleEngine_Object = '[RuleEngine] Initialize_DefaultRuleEngine_Object'
}

export const saveRuleEngineObj = createAction(
  RuleEngineActionTypes.Save_Rule_Engine_Obj,
  props<{ ruleObj: any }>()
);

export const initializeDefaultRuleEngineObj = createAction(
  RuleEngineActionTypes.Initialize_DefaultRuleEngine_Object,
  props<{flag?:any}>()
);

